import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS, QUERY_KEYS } from '~shared/api/query-keys';

import type {
  AnnouncementDetails,
  AnnouncementsResponse,
  GetAnnouncementsParams,
} from '../model/types';

export type {
  AnnouncementsResponse,
  GetAnnouncementsParams,
} from '../model/types';

export const getAnnouncementsAPI = async (
  params: GetAnnouncementsParams = {},
) => {
  const { page = 1, limit = 10, search, sortBy, sortOrder } = params;

  const response = await baseAPI.get<AnnouncementsResponse>('/announcements', {
    params: {
      page,
      limit,
      search: search ?? undefined,
      sortBy,
      sortOrder,
    },
  });
  return response.data;
};

export const getAnnouncementsOptions = (params: GetAnnouncementsParams = {}) =>
  queryOptions({
    queryKey: QUERY_KEYS.ANNOUNCEMENTS(params),
    queryFn: () => getAnnouncementsAPI(params),
    placeholderData: keepPreviousData,
  });

export const useGetAnnouncements = (params: GetAnnouncementsParams = {}) => {
  return useQuery(getAnnouncementsOptions(params));
};

export const getAnnouncementAPI = async (id: string) => {
  const response = await baseAPI.get<AnnouncementDetails>(
    `/announcements/${id}`,
  );
  return response.data;
};

export const useGetAnnouncement = (id: string) => {
  return useQuery({
    queryKey: [KEYS.ANNOUNCEMENTS, id],
    queryFn: () => getAnnouncementAPI(id),
    enabled: !!id,
  });
};
